import React, { useState, useEffect } from 'react';
import '../styles/components/_imageModal.scss';

interface ImageModalProps {
  src: string;
  alt: string;
  children?: React.ReactNode;
}

const ImageModal: React.FC<ImageModalProps> = ({ src, alt, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isOpen]);

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        className="image-modal__trigger"
        onClick={() => setIsOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setIsOpen(true);
          }
        }}
        aria-label={`Expand ${alt}`}
      >
        {children}
      </div>

      {isOpen && (
        <div
          className="image-modal__overlay"
          onClick={() => setIsOpen(false)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              setIsOpen(false);
            }
          }}
          aria-label="Close image"
        >
          <div
            className="image-modal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-modal__close"
              onClick={() => setIsOpen(false)}
              aria-label="Close modal"
            >
              ✕
            </button>
            <img src={src} alt={alt} className="image-modal__image" />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageModal;
